import { SVGProps } from "react"

interface Props extends SVGProps<SVGSVGElement> {
    color?: string;
}

const LocationIcon = ({ color = "#269FFF", ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="M2.917 4.083a4.083 4.083 0 1 0 8.166 0 4.083 4.083 0 0 0-8.166 0Z"
      />
      <path
        fill={color}
        d="M7 8.167A4.083 4.083 0 1 1 6.999 0 4.083 4.083 0 0 1 7 8.167ZM7 1.75a2.34 2.34 0 0 0-2.333 2.333A2.34 2.34 0 0 0 7 6.417a2.34 2.34 0 0 0 2.333-2.334A2.34 2.34 0 0 0 7 1.75Z"
      />
      <path
        fill={color}
        d="M7 7c.311 0 .583.272.583.583v5.834A.598.598 0 0 1 7 14a.598.598 0 0 1-.583-.583V7.583c0-.31.272-.583.583-.583Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default LocationIcon
